import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
// import { Panel, PanelGroup } from 'react-bootstrap';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import AppLink from 'components/common/AppLink';
import { setUserLogout } from 'components/actions/authActions';
import driverPic from 'components/assets/img/pks-oslo-driver.png';

class TransferPage extends React.Component {

  render() {
    const { isLogged, locale } = this.props;
    const heroImgAlt = TransHelper.translate(
      locale, "content.landing.transferPage.hero.imgAlt"
    );

    return (
      <div className="content content--lp content--lp-text">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="content.layout.sidebarAndHeader.help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text row--text-wide">
          <div className="transfer-page">

            <section className="transfer-page__hero">
              <div className="transfer-page__hero-copy">
                <p className="transfer-page__badge"><T>content.landing.transferPage.hero.badge</T></p>
                <h1><T>content.landing.transferPage.hero.title</T></h1>
                <p className="transfer-page__lede">
                  <T>content.landing.transferPage.hero.lede</T>
                </p>
                <ul className="transfer-page__kpis">
                  <li><T>content.landing.transferPage.hero.kpi.first</T></li>
                  <li><T>content.landing.transferPage.hero.kpi.second</T></li>
                  <li><T>content.landing.transferPage.hero.kpi.third</T></li>
                </ul>
                <div className="transfer-page__hero-actions">
                  <AppLink className="transfer-page__cta" to="routes.url.booking"><T>content.landing.transferPage.hero.cta</T></AppLink>
                  <span className="transfer-page__hint"><T>content.landing.transferPage.hero.hint</T></span>
                </div>
              </div>
              <div className="transfer-page__hero-visual">
                <div className="transfer-page__hero-card">
                  <img
                    src={driverPic}
                    alt={heroImgAlt}
                    loading="lazy"
                    width="800"
                    height="600"
                  />
                </div>
              </div>
            </section>

            <section className="transfer-page__section">
              <header className="transfer-page__section-header">
                <h2><T>content.landing.transferPage.benefits.title</T></h2>
                <p><T>content.landing.transferPage.benefits.subtitle</T></p>
              </header>
              <div className="transfer-page__benefits">
                <article className="transfer-page__benefit">
                  <h3><T>content.landing.transferPage.benefits.list.first.title</T></h3>
                  <p><T>content.landing.transferPage.benefits.list.first.description</T></p>
                </article>
                <article className="transfer-page__benefit">
                  <h3><T>content.landing.transferPage.benefits.list.second.title</T></h3>
                  <p><T>content.landing.transferPage.benefits.list.second.description</T></p>
                </article>
                <article className="transfer-page__benefit">
                  <h3><T>content.landing.transferPage.benefits.list.third.title</T></h3>
                  <p><T>content.landing.transferPage.benefits.list.third.description</T></p>
                </article>
              </div>
            </section>

            <section className="transfer-page__section transfer-page__section--process">
              <header className="transfer-page__section-header">
                <h2><T>content.landing.transferPage.process.title</T></h2>
                <p><T>content.landing.transferPage.process.subtitle</T></p>
              </header>
              <ol className="transfer-page__steps">
                <li><T>content.landing.transferPage.process.steps.first</T></li>
                <li><T>content.landing.transferPage.process.steps.second</T></li>
                <li><T>content.landing.transferPage.process.steps.third</T></li>
              </ol>
            </section>

            <section className="transfer-page__section transfer-page__section--comparison">
              <header className="transfer-page__section-header">
                <h2><T>content.landing.transferPage.comparison.title</T></h2>
                <p><T>content.landing.transferPage.comparison.subtitle</T></p>
              </header>
              <div className="transfer-page__table-wrapper">
                <table className="transfer-page__table">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col"><T>content.landing.transferPage.comparison.columns.pks</T></th>
                      <th scope="col"><T>content.landing.transferPage.comparison.columns.flybussen</T></th>
                      <th scope="col"><T>content.landing.transferPage.comparison.columns.taxi</T></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.pickup.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.pickup.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.pickup.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.pickup.taxi</T></td>
                    </tr>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.price.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.price.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.price.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.price.taxi</T></td>
                    </tr>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.duration.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.duration.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.duration.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.duration.taxi</T></td>
                    </tr>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.stops.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.stops.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.stops.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.stops.taxi</T></td>
                    </tr>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.luggage.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.luggage.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.luggage.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.luggage.taxi</T></td>
                    </tr>
                    <tr>
                      <th scope="row"><T>content.landing.transferPage.comparison.rows.language.label</T></th>
                      <td><T>content.landing.transferPage.comparison.rows.language.pks</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.language.flybussen</T></td>
                      <td><T>content.landing.transferPage.comparison.rows.language.taxi</T></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="transfer-page__disclaimer"><T>content.landing.transferPage.comparison.disclaimer</T></p>
            </section>

            <section className="transfer-page__section transfer-page__section--highlight">
              <header className="transfer-page__section-header">
                <h2><T>content.landing.transferPage.quotes.title</T></h2>
              </header>
              <div className="transfer-page__quotes">
                <blockquote>
                  <T>content.landing.transferPage.quotes.first.text</T>
                  <cite><T>content.landing.transferPage.quotes.first.cite</T></cite>
                </blockquote>
                <blockquote>
                  <T>content.landing.transferPage.quotes.second.text</T>
                  <cite><T>content.landing.transferPage.quotes.second.cite</T></cite>
                </blockquote>
              </div>
            </section>

            <section className="transfer-page__section transfer-page__section--info">
              <header className="transfer-page__section-header">
                <h2><T>content.landing.transferPage.info.title</T></h2>
              </header>
              <p><T>content.landing.transferPage.info.first</T></p>
              <p><T>content.landing.transferPage.info.second</T></p>
            </section>

            <div className="transfer-page__floating-cta">
              <AppLink className="transfer-page__cta transfer-page__cta--floating" to="routes.url.booking"><T>content.landing.transferPage.hero.cta</T></AppLink>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(TransferPage));
